export default __webpack_public_path__ + "static/media/login-bg-27.a106175f.jpg";